export enum GoogleAnalyticsEvents {
  LessonStarted = 'lesson_started',
  LessonOpened = 'lesson_opened',
  LessonCompleted = 'lesson_completed',
  LessonRated = 'lesson_rated',
  ActivityCompleted = 'activity_completed',
  BookClassOpen = 'book_class_open',
  BookClassClose = 'book_class_close',
  BookPrivateClass = 'book_private_class',
  BookGroupClass = 'book_group_class',
  BookGameClass = 'book_game_class',
  BookOrientationClass = 'book_orientation_class',
  JoinLiveClass = 'join_live_class',
  LoginRequest = 'login_request',
  LoginError = 'login_error',
  P2LErrorButtonPress = 'p2l-error-button-press',
  P2LJoinButtonPress = 'p2l-join-button-press',
  P2LSDKDisabledButtonPress = 'p2l-sdk-disabled-button-press',
  SkipPlacementTest = 'skip_placement_test',
  ViewPlacementTestInstructions = 'view_placement_test_instructions',
  PlacementTestBeginClicked = 'placement_test_begin_clicked',
  PlacementTestSkipFromInstructionsClicked = 'placement_test_skip_from_instructions_clicked',
  // TODO: Add when merged the branch OEJRLMS-2594_Pre_class_activity_player
  // OpenPreClassActivities = 'open_pre_class_activities',
}
